import styles from './Loading.module.css'

function Loading() {
  return <div className={styles.spinner} />
}

export default Loading
